@if (emailsLoaded) {
<div class="tw-bg-gray-100 dark:tw-bg-gray-900 tw-grid profile-settings-grid">
  <!-- Sidebar (same structure/classes as Organization Settings) -->
  <!--
    Important: keep the grid's first column occupied (like organization settings).
    The fixed sidebar is nested INSIDE this wrapper so the grid can place content in column 2 on desktop.
  -->
  <div class="profile-settings-sidebar-host">
    <!-- Sidebar (match organization settings sidebar markup/classes exactly) -->
    <section class="tw-fixed tw-z-10 tw-w-full lg:tw-w-auto">
      <div>
        <h1 class="tw-text-lg md:tw-text-xl tw-font-bold lg:tw-hidden tw-bg-white dark:tw-bg-gray-800 tw-px-4 tw-py-3 dark:tw-text-gray-100 tw-shadow-[0px_1px_2px_0px_#00000014]">
          Profile Settings
        </h1>
      </div>
      <div
        class="scrollbar-hide-md tw-overflow-x-auto tw-overflow-y-hidden lg:tw-overflow-visible lg:tw-w-[256px] lg:tw-h-screen tw-bg-gray-100 dark:tw-bg-gray-900 lg:tw-bg-white lg:dark:tw-bg-gray-800"
      >
        <ul
          class="tw-bg-gray-100 dark:tw-bg-gray-900 lg:tw-bg-white lg:dark:tw-bg-gray-800 tw-p-4 tw-pb-4 md:tw-pt-8 md:tw-pb-3 tw-flex tw-w-full tw-text-sm tw-font-medium tw-text-center tw-gap-3 lg:tw-gap-4 lg:tw-flex-col lg:tw-text-left lg:tw-pt-10"
        >
          <li class="tw-flex-1 lg:tw-flex-none tw-bg-gray-100 dark:tw-bg-gray-900 tw-rounded-md py-[10px]">
            <a
              class="tw-gap-1 lg:tw-gap-2 tw-text-sm tw-font-medium nav-button tw-inline-flex tw-items-center tw-justify-center tw-rounded-md tw-group tw-w-full tw-cursor-pointer tw-py-2 tw-px-4 md:tw-py-3 lg:tw-justify-start lg:tw-text-left lg:tw-py-[10px]"
              [ngClass]="{
                'tw-text-white tw-bg-blue-600 tw-border-blue-600 dark:tw-bg-blue-600 dark:tw-text-white hover:tw-text-white': activeTab === 'account',
                'hover:tw-text-gray-600 tw-border-transparent hover:tw-border-gray-300 dark:hover:tw-text-gray-300 tw-text-gray-500 group-hover:tw-text-gray-500 dark:tw-text-gray-400 dark:group-hover:tw-text-gray-300':
                  activeTab !== 'account'
              }"
              (click)="setActiveTab('account'); scrollToSection('account')"
            >
              <span [innerHTML]="getProfileSidebarIcon(profileSidebarIcons.account, activeTab === 'account')"></span>
              <span class="tw-font-inter">Account</span>
            </a>
          </li>
          <li class="tw-flex-1 lg:tw-flex-none tw-bg-gray-100 dark:tw-bg-gray-900 tw-rounded-md py-[10px]">
            <a
              class="tw-gap-1 lg:tw-gap-2 tw-text-sm tw-font-medium nav-button tw-inline-flex tw-items-center tw-justify-center tw-rounded-md tw-group tw-w-full tw-cursor-pointer tw-py-2 tw-px-4 md:tw-py-3 lg:tw-justify-start lg:tw-text-left lg:tw-py-[10px]"
              [ngClass]="{
                'tw-text-white tw-bg-blue-600 tw-border-blue-600 dark:tw-bg-blue-600 dark:tw-text-white hover:tw-text-white': activeTab === 'email',
                'hover:tw-text-gray-600 tw-border-transparent hover:tw-border-gray-300 dark:hover:tw-text-gray-300 tw-text-gray-500 group-hover:tw-text-gray-500 dark:tw-text-gray-400 dark:group-hover:tw-text-gray-300':
                  activeTab !== 'email'
              }"
              (click)="setActiveTab('email'); scrollToSection('email-management')"
            >
              <span [innerHTML]="getProfileSidebarIcon(profileSidebarIcons.email, activeTab === 'email')"></span>
              <span class="tw-font-inter">Email</span>
            </a>
          </li>
          <li class="tw-flex-1 lg:tw-flex-none tw-bg-gray-100 dark:tw-bg-gray-900 tw-rounded-md py-[10px]">
            <a
              class="tw-gap-1 lg:tw-gap-2 tw-text-sm tw-font-medium nav-button tw-inline-flex tw-items-center tw-justify-center tw-rounded-md tw-group tw-w-full tw-cursor-pointer tw-py-2 tw-px-4 md:tw-py-3 lg:tw-justify-start lg:tw-text-left lg:tw-py-[10px]"
              [ngClass]="{
                'tw-text-white tw-bg-blue-600 tw-border-blue-600 dark:tw-bg-blue-600 dark:tw-text-white hover:tw-text-white': activeTab === 'mfa',
                'hover:tw-text-gray-600 tw-border-transparent hover:tw-border-gray-300 dark:hover:tw-text-gray-300 tw-text-gray-500 group-hover:tw-text-gray-500 dark:tw-text-gray-400 dark:group-hover:tw-text-gray-300':
                  activeTab !== 'mfa'
              }"
              (click)="setActiveTab('mfa'); scrollToSection('mfa')"
            >
              <span [innerHTML]="getProfileSidebarIcon(profileSidebarIcons.mfa, activeTab === 'mfa')"></span>
              <span class="tw-font-inter">MFA</span>
            </a>
          </li>
          <li class="tw-flex-1 lg:tw-flex-none tw-bg-gray-100 dark:tw-bg-gray-900 tw-rounded-md py-[10px]">
            <a
              class="tw-gap-1 lg:tw-gap-2 tw-text-sm tw-font-medium nav-button tw-inline-flex tw-items-center tw-justify-center tw-rounded-md tw-group tw-w-full tw-cursor-pointer tw-py-2 tw-px-4 md:tw-py-3 lg:tw-justify-start lg:tw-text-left lg:tw-py-[10px]"
              [ngClass]="{
                'tw-text-white tw-bg-blue-600 tw-border-blue-600 dark:tw-bg-blue-600 dark:tw-text-white hover:tw-text-white': activeTab === 'passkeys',
                'hover:tw-text-gray-600 tw-border-transparent hover:tw-border-gray-300 dark:hover:tw-text-gray-300 tw-text-gray-500 group-hover:tw-text-gray-500 dark:tw-text-gray-400 dark:group-hover:tw-text-gray-300':
                  activeTab !== 'passkeys'
              }"
              (click)="setActiveTab('passkeys'); scrollToSection('passkeys')"
            >
              <span [innerHTML]="getProfileSidebarIcon(profileSidebarIcons.passkeys, activeTab === 'passkeys')"></span>
              <span class="tw-font-inter">Passkeys</span>
            </a>
          </li>
          <li class="tw-flex-1 lg:tw-flex-none tw-bg-gray-100 dark:tw-bg-gray-900 tw-rounded-md py-[10px]">
            <a
              class="tw-gap-1 lg:tw-gap-2 tw-text-sm tw-font-medium nav-button tw-inline-flex tw-items-center tw-justify-center tw-rounded-md tw-group tw-w-full tw-cursor-pointer tw-py-2 tw-px-4 md:tw-py-3 lg:tw-justify-start lg:tw-text-left lg:tw-py-[10px]"
              [ngClass]="{
                'tw-text-white tw-bg-blue-600 tw-border-blue-600 dark:tw-bg-blue-600 dark:tw-text-white hover:tw-text-white': activeTab === 'devices',
                'hover:tw-text-gray-600 tw-border-transparent hover:tw-border-gray-300 dark:hover:tw-text-gray-300 tw-text-gray-500 group-hover:tw-text-gray-500 dark:tw-text-gray-400 dark:group-hover:tw-text-gray-300':
                  activeTab !== 'devices'
              }"
              (click)="setActiveTab('devices'); scrollToSection('linked-devices')"
            >
              <span [innerHTML]="getProfileSidebarIcon(profileSidebarIcons.devices, activeTab === 'devices')"></span>
              <span class="tw-font-inter">Devices</span>
            </a>
          </li>
          <li class="tw-flex-1 lg:tw-flex-none tw-bg-gray-100 dark:tw-bg-gray-900 tw-rounded-md py-[10px]">
            <a
              class="tw-gap-1 lg:tw-gap-2 tw-text-sm tw-font-medium nav-button tw-inline-flex tw-items-center tw-justify-center tw-rounded-md tw-group tw-w-full tw-cursor-pointer tw-py-2 tw-px-4 md:tw-py-3 lg:tw-justify-start lg:tw-text-left lg:tw-py-[10px]"
              [ngClass]="{
                'tw-text-white tw-bg-blue-600 tw-border-blue-600 dark:tw-bg-blue-600 dark:tw-text-white hover:tw-text-white': activeTab === 'password',
                'hover:tw-text-gray-600 tw-border-transparent hover:tw-border-gray-300 dark:hover:tw-text-gray-300 tw-text-gray-500 group-hover:tw-text-gray-500 dark:tw-text-gray-400 dark:group-hover:tw-text-gray-300':
                  activeTab !== 'password'
              }"
              (click)="setActiveTab('password'); scrollToSection('password')"
            >
              <span [innerHTML]="getProfileSidebarIcon(profileSidebarIcons.password, activeTab === 'password')"></span>
              <span class="tw-font-inter">Password</span>
            </a>
          </li>
        </ul>
      </div>
    </section>
  </div>

  <!-- Content -->
  <div class="tw-flex tw-flex-col tw-gap-6 tw-mb-20 lg:tw-mt-6 tw-px-4 lg:tw-mx-auto profile-content">
    <h1 class="tw-font-bold tw-hidden lg:tw-block dark:tw-text-gray-100">Profile Settings</h1>

    <!-- Account -->
    <section
      id="account"
      class="tw-w-full tw-flex tw-flex-col tw-m-auto tw-p-4 md:tw-px-6 tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-shadow-sm tw-rounded-xl tw-bg-white dark:tw-bg-gray-800"
    >
      <div class="tw-mb-4 tw-flex tw-flex-col tw-gap-1 tw-items-start">
        <h2 class="tw-font-bold tw-text-gray-700 dark:tw-text-gray-100 tw-text-lg tw-font-inter">Account</h2>
        <p class="tw-text-sm tw-max-w-[660px] tw-text-gray-500 dark:tw-text-gray-300 tw-text-start tw-font-inter tw-font-normal">
          Update your profile picture and personal details.
        </p>
      </div>

      <div [formGroup]="profileForm" class="tw-flex tw-flex-col tw-gap-4">
        <input type="hidden" formControlName="profile_picture" />

        <div class="tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-rounded-xl tw-p-4 tw-flex tw-flex-col md:tw-flex-row tw-gap-1 md:tw-gap-4">
          <div class="tw-w-full md:tw-w-[144px] lg:tw-w-[152px] lg:tw-flex-shrink-0 tw-mb-3 md:tw-mb-0">
            <app-upload
              [fileList]="profilePictureFile"
              accept=".jpg, .png, .jpeg"
              [maxFileSize]="2 * 1024"
              [deleteFileWithAPI]="true"
              [width]="'152px'"
              [height]="'152px'"
              [componentMinHeight]="'180px'"
              label="Profile picture"
              [apiPayload]="{
                user_id: auth.user?.id,
                type: uploadTypeEnum.USER
              }"
              (fileChanged)="onProfilePictureChanged($event); onMyInfoBlur()"
              (fileDeleted)="onProfilePictureDeleted(); onMyInfoBlur()"
            >
            </app-upload>
          </div>

          <div class="tw-flex tw-flex-col tw-flex-1 tw-gap-1">
            <basic-input
              [control]="$any(profileForm.controls.full_name)"
              [placeholder]="'Full name'"
              [id]="'profile-full-name'"
              [mode]="BasicInputMode.INLINE"
              [allowClearButton]="false"
              [required]="true"
              [icon]="profileIcons.user"
              [iconType]="'fill'"
              (onBlurValueChange)="onMyInfoBlur()"
              (onKeydown)="onMyInfoKeydown($event)"
            ></basic-input>

            <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 md:tw-gap-2 lg:tw-gap-3">
              <basic-input
                [control]="$any(profileForm.controls.job_title)"
                [placeholder]="'Job title'"
                [id]="'profile-job-title'"
                [mode]="BasicInputMode.INLINE"
                [allowClearButton]="false"
                [icon]="profileIcons.job"
                [iconType]="'fill'"
                (onBlurValueChange)="onMyInfoBlur()"
                (onKeydown)="onMyInfoKeydown($event)"
              ></basic-input>

              <phone-input
                [control]="$any(profileForm.controls.phone_number)"
                [id]="'profile-phone-number'"
                [placeholder]="'Phone number'"
                [mode]="BasicInputMode.INLINE"
                [allowClearButton]="false"
                [required]="true"
                [icon]="profileIcons.phone"
                [iconType]="'fill'"
                (onBlurValueChange)="onMyInfoBlur()"
                (onKeydown)="onMyInfoKeydown($event)"
              ></phone-input>
            </div>
          </div>
        </div>

        <!-- Saved automatically on blur / Enter (same UX as organization settings) -->
      </div>
    </section>

    <!-- Email management -->
    <section
      id="email-management"
      class="tw-w-full tw-flex tw-flex-col tw-m-auto tw-p-4 md:tw-px-6 tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-shadow-sm tw-rounded-xl tw-bg-white dark:tw-bg-gray-800"
    >
      <div class="tw-mb-4 tw-flex tw-flex-col tw-gap-1 tw-items-start">
        <h2 class="tw-font-bold tw-text-gray-700 dark:tw-text-gray-100 tw-text-lg tw-font-inter">Email management</h2>
        <p class="tw-text-sm tw-max-w-[660px] tw-text-gray-500 dark:tw-text-gray-300 tw-text-start tw-font-inter tw-font-normal">
          Manage your primary and alternative email addresses.
        </p>
      </div>

      <div [formGroup]="profileForm" class="tw-flex tw-flex-col tw-gap-4">
        <div class="tw-flex tw-flex-col tw-gap-2">
          <!-- Primary email (highlighted, not removable) -->
          <div class="tw-rounded-xl tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-bg-gray-50 dark:tw-bg-gray-700/40 tw-p-4">
            <div class="tw-flex tw-items-center tw-justify-between tw-gap-3">
              <div class="tw-flex tw-items-center tw-gap-3">
                <div class="tw-text-gray-500 dark:tw-text-gray-300" [innerHTML]="profileIcons.email"></div>
                <div class="tw-text-sm tw-font-medium tw-text-gray-700 dark:tw-text-gray-100 tw-font-inter">
                  {{ profileForm.controls.primary_email.value }}
                </div>
              </div>

              <span class="tw-rounded-full tw-bg-blue-100 tw-text-blue-700 tw-px-2 tw-py-0.5 tw-text-[11px] tw-font-semibold">Primary</span>
            </div>
          </div>
        </div>

        <div class="tw-border-t tw-border-gray-200 dark:tw-border-gray-600 tw-pt-4">
          <p class="tw-text-sm tw-text-gray-500 dark:tw-text-gray-300 tw-mt-1 tw-font-inter">
            Add additional email addresses for notifications and backup purposes.
          </p>

          <div formArrayName="emails" class="tw-mt-4 tw-flex tw-flex-col tw-gap-3">
            <div *ngFor="let emailGroup of emailsArray.controls; let i = index" [formGroupName]="i" class="tw-relative email-field-container">
              <!-- If already added (verified or has id) and not being edited, show as a card like primary -->
              <ng-container *ngIf="(isEmailVerified(i) || emailGroup.get('id')?.value) && !isEmailModified(i); else altEmailEditor">
                <div class="tw-rounded-xl tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-bg-gray-50 dark:tw-bg-gray-700/40 tw-p-4">
                  <div class="tw-flex tw-items-center tw-justify-between tw-gap-3">
                    <div class="tw-flex tw-items-center tw-gap-3">
                      <div class="tw-text-gray-500 dark:tw-text-gray-300" [innerHTML]="profileIcons.email"></div>
                      <div class="tw-text-sm tw-font-medium tw-text-gray-700 dark:tw-text-gray-100 tw-font-inter">
                        {{ emailGroup.get('email')?.value }}
                      </div>
                    </div>

                    <div class="tw-flex tw-items-center tw-gap-3">
                      <span
                        class="tw-rounded-full tw-bg-gray-100 dark:tw-bg-gray-700 tw-text-gray-700 dark:tw-text-gray-200 tw-px-2 tw-py-0.5 tw-text-[11px] tw-font-semibold"
                      >
                        Alternative
                      </span>
                      <button
                        type="button"
                        (click)="deleteIdentifier(i)"
                        class="tw-text-[12px] tw-font-semibold tw-text-red-600/90 hover:tw-text-red-700 tw-font-inter"
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                </div>
              </ng-container>

              <!-- Editor for new/unsaved or modified alternative email -->
              <ng-template #altEmailEditor>
                <email-input
                  [control]="$any(emailGroup.get('email'))"
                  [label]="'Email'"
                  [id]="'profile-alt-email-' + i"
                  [allowClearButton]="false"
                ></email-input>

                <!-- actions -->
                <div class="tw-mt-1 tw-flex tw-items-center tw-justify-end tw-gap-4">
                  <button
                    *ngIf="isEmailValid(i) && !isEmailCreating(i) && isEmailModified(i)"
                    type="button"
                    (click)="createIdentifier(i)"
                    class="tw-text-sm tw-font-semibold tw-text-green-700 hover:tw-text-green-800 tw-font-inter"
                  >
                    {{ isEmailVerified(i) ? 'Update' : 'Save' }}
                  </button>

                  <div *ngIf="isEmailCreating(i)" class="tw-text-sm tw-text-yellow-700 tw-font-inter tw-inline-flex tw-items-center tw-gap-2" title="Saving…">
                    <mat-icon class="tw-text-inherit tw-text-[18px] spinning">hourglass_empty</mat-icon>
                    Saving…
                  </div>

                  <button
                    *ngIf="emailsArray.length > 0 && !emailGroup.get('id')?.value"
                    type="button"
                    (click)="deleteIdentifier(i)"
                    class="tw-text-[12px] tw-font-semibold tw-text-gray-500 hover:tw-text-gray-700 tw-font-inter"
                  >
                    Cancel
                  </button>

                  <button
                    *ngIf="emailsArray.length > 0 && emailGroup.get('id')?.value"
                    type="button"
                    (click)="deleteIdentifier(i)"
                    class="tw-text-[12px] tw-font-semibold tw-text-red-600/90 hover:tw-text-red-700 tw-font-inter"
                  >
                    Remove
                  </button>
                </div>
              </ng-template>
            </div>
          </div>

          <div class="tw-mt-3 tw-text-sm tw-text-red-600" *ngIf="profileForm.get('emails').errors?.duplicateEmails">
            Duplicate email addresses are not allowed.
          </div>

          <div class="tw-mt-4" *ngIf="canAddEmail">
            <button
              type="button"
              (click)="addEmail()"
              class="tw-w-full tw-rounded-lg tw-border tw-border-dashed tw-border-gray-300 dark:tw-border-gray-600 tw-bg-transparent hover:tw-bg-gray-50 dark:hover:tw-bg-gray-700 tw-px-4 tw-py-3 tw-text-sm tw-font-semibold tw-text-gray-700 dark:tw-text-gray-100 tw-inline-flex tw-items-center tw-justify-center tw-gap-2"
            >
              <mat-icon class="tw-text-inherit">add</mat-icon>
              Add alternative email
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- MFA -->
    <section
      id="mfa"
      class="tw-w-full tw-flex tw-flex-col tw-m-auto tw-p-4 md:tw-px-6 tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-shadow-sm tw-rounded-xl tw-bg-white dark:tw-bg-gray-800"
    >
      <div class="tw-mb-4 tw-flex tw-items-start tw-justify-between tw-gap-3">
        <div class="tw-flex tw-flex-col tw-gap-1 tw-items-start">
          <h2 class="tw-font-bold tw-text-gray-700 dark:tw-text-gray-100 tw-text-lg tw-font-inter">Two-factor authentication (MFA)</h2>
          <p class="tw-text-sm tw-max-w-[660px] tw-text-gray-500 dark:tw-text-gray-300 tw-text-start tw-font-inter tw-font-normal">
            Protect your account by requiring a secure code when signing in.
          </p>
        </div>

        @if (enabledMFAType !== null) {
          <button
            type="button"
            class="tw-text-sm tw-font-semibold tw-text-red-600/90 hover:tw-text-red-700 tw-font-inter disabled:tw-opacity-60"
            (click)="onMfaToggle(enabledMFAType!, $event)"
          >
            Disable MFA
          </button>
        }
      </div>

      <!-- Choose method (cards) -->
      <div class="tw-mt-4 tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-3">
        <button
          type="button"
          class="tw-relative tw-rounded-xl tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-bg-gray-50 dark:tw-bg-gray-700/40 tw-p-4 hover:tw-bg-gray-100 dark:hover:tw-bg-gray-700 tw-transition tw-text-center"
          [ngClass]="{ 'tw-opacity-60 tw-pointer-events-none': isMfaFactorDisabled(MFA_FACTOR_TYPE.APP), 'tw-ring-2 tw-ring-blue-600': enabledMFAType === MFA_FACTOR_TYPE.APP }"
          (click)="onMfaToggle(MFA_FACTOR_TYPE.APP, $event)"
        >
          @if (enabledMFAType === MFA_FACTOR_TYPE.APP) {
            <div class="tw-absolute tw-top-3 tw-right-3 tw-text-blue-600 dark:tw-text-blue-400">
              <mat-icon class="tw-text-inherit">check_circle</mat-icon>
            </div>
          }
          <div class="tw-flex tw-flex-col tw-items-center tw-gap-2">
            <div class="tw-w-12 tw-h-12 tw-rounded-xl tw-bg-white dark:tw-bg-gray-800 tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-flex tw-items-center tw-justify-center tw-text-gray-700 dark:tw-text-gray-100">
              <mat-icon class="tw-text-inherit tw-text-[26px]">qr_code_2</mat-icon>
            </div>
            <div class="tw-font-semibold tw-text-gray-800 dark:tw-text-gray-100 tw-font-inter">Authenticator app</div>
            <div class="tw-text-xs tw-text-gray-500 dark:tw-text-gray-300 tw-font-inter">Use an app to generate secure codes.</div>
          </div>
        </button>

        <button
          type="button"
          class="tw-relative tw-rounded-xl tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-bg-gray-50 dark:tw-bg-gray-700/40 tw-p-4 hover:tw-bg-gray-100 dark:hover:tw-bg-gray-700 tw-transition tw-text-center"
          [ngClass]="{ 'tw-opacity-60 tw-pointer-events-none': isMfaFactorDisabled(MFA_FACTOR_TYPE.EMAIL), 'tw-ring-2 tw-ring-blue-600': enabledMFAType === MFA_FACTOR_TYPE.EMAIL }"
          (click)="onMfaToggle(MFA_FACTOR_TYPE.EMAIL, $event)"
        >
          @if (enabledMFAType === MFA_FACTOR_TYPE.EMAIL) {
            <div class="tw-absolute tw-top-3 tw-right-3 tw-text-blue-600 dark:tw-text-blue-400">
              <mat-icon class="tw-text-inherit">check_circle</mat-icon>
            </div>
          }
          <div class="tw-flex tw-flex-col tw-items-center tw-gap-2">
            <div class="tw-w-12 tw-h-12 tw-rounded-xl tw-bg-white dark:tw-bg-gray-800 tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-flex tw-items-center tw-justify-center tw-text-gray-700 dark:tw-text-gray-100">
              <mat-icon class="tw-text-inherit tw-text-[26px]">mail</mat-icon>
            </div>
            <div class="tw-font-semibold tw-text-gray-800 dark:tw-text-gray-100 tw-font-inter">Email</div>
            <div class="tw-text-xs tw-text-gray-500 dark:tw-text-gray-300 tw-font-inter">Receive a code by email when signing in.</div>
          </div>
        </button>

        <button
          type="button"
          class="tw-relative tw-rounded-xl tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-bg-gray-50 dark:tw-bg-gray-700/40 tw-p-4 hover:tw-bg-gray-100 dark:hover:tw-bg-gray-700 tw-transition tw-text-center"
          [ngClass]="{ 'tw-opacity-60 tw-pointer-events-none': isMfaFactorDisabled(MFA_FACTOR_TYPE.PHONE), 'tw-ring-2 tw-ring-blue-600': enabledMFAType === MFA_FACTOR_TYPE.PHONE }"
          (click)="onMfaToggle(MFA_FACTOR_TYPE.PHONE, $event)"
        >
          @if (enabledMFAType === MFA_FACTOR_TYPE.PHONE) {
            <div class="tw-absolute tw-top-3 tw-right-3 tw-text-blue-600 dark:tw-text-blue-400">
              <mat-icon class="tw-text-inherit">check_circle</mat-icon>
            </div>
          }
          <div class="tw-flex tw-flex-col tw-items-center tw-gap-2">
            <div class="tw-w-12 tw-h-12 tw-rounded-xl tw-bg-white dark:tw-bg-gray-800 tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-flex tw-items-center tw-justify-center tw-text-gray-700 dark:tw-text-gray-100">
              <mat-icon class="tw-text-inherit tw-text-[26px]">sms</mat-icon>
            </div>
            <div class="tw-font-semibold tw-text-gray-800 dark:tw-text-gray-100 tw-font-inter">SMS</div>
            <div class="tw-text-xs tw-text-gray-500 dark:tw-text-gray-300 tw-font-inter">Receive a code by SMS when signing in.</div>
          </div>
        </button>
      </div>
    </section>

    <!-- Passkeys -->
    <section
      id="passkeys"
      class="tw-w-full tw-flex tw-flex-col tw-m-auto tw-p-4 md:tw-px-6 tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-shadow-sm tw-rounded-xl tw-bg-white dark:tw-bg-gray-800"
    >
      <div class="tw-mb-4 tw-flex tw-items-start tw-justify-between tw-gap-3">
        <div class="tw-flex tw-flex-col tw-gap-1 tw-items-start">
          <h2 class="tw-font-bold tw-text-gray-700 dark:tw-text-gray-100 tw-text-lg tw-font-inter">Passkeys</h2>
          <p class="tw-text-sm tw-max-w-[660px] tw-text-gray-500 dark:tw-text-gray-300 tw-text-start tw-font-inter tw-font-normal">
            Use Face ID, Touch ID, Windows Hello, or a hardware key to sign in faster and more securely.
          </p>
        </div>
      </div>

      <div class="tw-flex tw-flex-col tw-gap-3">
        <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-3 md:tw-items-end">
          <basic-input
            [control]="$any(passkeyNameControl)"
            [label]="'Passkey name (optional)'"
            [placeholder]="'e.g. My MacBook'"
            [id]="'passkey-name'"
            [mode]="BasicInputMode.DEFAULT"
            [allowClearButton]="false"
          ></basic-input>

          <button
            type="button"
            class="tw-ml-auto tw-whitespace-nowrap tw-rounded-lg tw-bg-blue-600 hover:tw-bg-blue-700 tw-text-white tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-font-inter disabled:tw-opacity-60"
            [disabled]="addingPasskey"
            (click)="addPasskey()"
          >
            {{ addingPasskey ? 'Adding…' : 'Add passkey' }}
          </button>
        </div>

        @if (!passkeysLoaded || passkeysLoading) {
          <div class="tw-text-sm tw-text-gray-500 dark:tw-text-gray-300">Loading passkeys…</div>
        } @else if (!passkeys?.length) {
          <div class="tw-text-sm tw-text-gray-500 dark:tw-text-gray-300">No passkeys added yet.</div>
        } @else {
          <div class="tw-flex tw-flex-col tw-gap-3">
            @for (p of passkeys; track p.id) {
              <div class="tw-rounded-xl tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-bg-gray-50 dark:tw-bg-gray-700/40 tw-p-4">
                <div class="tw-flex tw-items-start tw-gap-3">
                  <div
                    class="tw-w-9 tw-h-9 tw-rounded-lg tw-bg-white dark:tw-bg-gray-800 tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-flex tw-items-center tw-justify-center tw-text-gray-700 dark:tw-text-gray-100"
                  >
                    <mat-icon class="tw-text-inherit">key</mat-icon>
                  </div>
                  <div class="tw-flex tw-flex-col tw-gap-1">
                    <div class="tw-text-sm tw-font-semibold tw-text-gray-800 dark:tw-text-gray-100 tw-font-inter">
                      {{ p.name || 'Passkey' }}
                    </div>
                    <div class="tw-text-xs tw-text-gray-500 dark:tw-text-gray-300 tw-font-inter">
                      Created {{ p.created_at ? (p.created_at | date: 'MMM d, y') : '—' }} · Last used {{ p.last_used_at ? (p.last_used_at | date: 'MMM d, y') : '—' }}
                    </div>
                  </div>

                  <button
                    type="button"
                    class="tw-ml-auto tw-text-sm tw-font-semibold tw-text-red-600/90 hover:tw-text-red-700 tw-font-inter disabled:tw-opacity-60"
                    [disabled]="deletingPasskeyId === p.id"
                    (click)="deletePasskey(p.id)"
                  >
                    {{ deletingPasskeyId === p.id ? 'Removing…' : 'Remove' }}
                  </button>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </section>

    <!-- Linked devices -->
    <section
      id="linked-devices"
      class="tw-w-full tw-flex tw-flex-col tw-m-auto tw-p-4 md:tw-px-6 tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-shadow-sm tw-rounded-xl tw-bg-white dark:tw-bg-gray-800"
    >
      <div class="tw-mb-4 tw-flex tw-items-start tw-justify-between tw-gap-3">
        <div class="tw-flex tw-flex-col tw-gap-1 tw-items-start">
          <h2 class="tw-font-bold tw-text-gray-700 dark:tw-text-gray-100 tw-text-lg tw-font-inter">Devices</h2>
          <p class="tw-text-sm tw-max-w-[660px] tw-text-gray-500 dark:tw-text-gray-300 tw-text-start tw-font-inter tw-font-normal">
            Devices where you’re currently signed in. You can log out a single device, or log out from all other devices.
          </p>
        </div>
      </div>

      <div class="tw-flex tw-flex-col tw-gap-3">
        @if (!devicesLoaded) {
          <div class="tw-text-sm tw-text-gray-500 dark:tw-text-gray-300">Loading linked devices…</div>
        } @else if (!sessions?.length) {
          <div class="tw-text-sm tw-text-gray-500 dark:tw-text-gray-300">No linked devices found.</div>
        } @else {
          @for (session of sessions; track session.id) {
            <div class="tw-rounded-xl tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-bg-gray-50 dark:tw-bg-gray-700/40 tw-p-4">
              <div class="tw-flex tw-flex-col tw-gap-3">
                <div class="tw-flex tw-flex-col tw-gap-3">
                  <div class="tw-flex tw-items-start tw-gap-3">
                    <div class="tw-flex tw-items-center tw-gap-2">
                      <div
                        class="tw-w-9 tw-h-9 tw-rounded-lg tw-bg-white dark:tw-bg-gray-800 tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-flex tw-items-center tw-justify-center tw-text-gray-700 dark:tw-text-gray-100"
                      >
                        <mat-icon class="tw-text-inherit">devices</mat-icon>
                      </div>
                      <div class="tw-flex tw-flex-col">
                        <div class="tw-text-sm tw-font-semibold tw-text-gray-800 dark:tw-text-gray-100 tw-font-inter">
                          {{ getDeviceTitle(session) }}
                        </div>
                        <div class="tw-text-xs tw-text-gray-500 dark:tw-text-gray-300 tw-font-inter">Last active {{ session.last_activity_human }}</div>
                      </div>
                    </div>

                    <div class="tw-ml-auto tw-flex tw-items-center tw-gap-3 tw-flex-shrink-0">
                      <span
                        *ngIf="isCurrentSession(session)"
                        class="tw-rounded-full tw-bg-blue-100 tw-text-blue-700 tw-px-2 tw-py-0.5 tw-text-[11px] tw-font-semibold"
                      >
                        This device
                      </span>
                    </div>
                  </div>

                  <div class="tw-flex tw-items-center tw-gap-3 tw-w-full">
                    <div class="tw-text-xs tw-text-gray-500 dark:tw-text-gray-300 tw-font-inter tw-flex-1 tw-min-w-0">
                        <ng-container *ngIf="session.ip_address; else noIp">
                          @if (hasSessionLocation(session)) {
                            <button
                              type="button"
                              class="tw-text-blue-600 dark:tw-text-blue-400 tw-font-semibold hover:tw-underline"
                              title="Location from IP address (ipwho.is)"
                              (click)="openDeviceLocation(session)"
                            >
                              {{ getSessionLocationLabel(session) }}
                            </button>
                          } @else {
                            <span class="tw-text-gray-500 dark:tw-text-gray-300">Unknown location</span>
                          }
                          <span class="tw-ml-2 tw-text-gray-400">•</span>
                          <span class="tw-ml-2">IP {{ session.ip_address }}</span>
                        </ng-container>
                        <ng-template #noIp>Unknown location</ng-template>
                      </div>

                      @if (!isCurrentSession(session)) {
                        <button
                          type="button"
                          class="tw-text-[12px] tw-font-semibold tw-text-red-600/90 hover:tw-text-red-700 tw-font-inter disabled:tw-opacity-60 tw-flex-shrink-0 tw-ml-auto"
                          [disabled]="revokingSessionId === session.id"
                          (click)="revokeSession(session.id)"
                        >
                          {{ revokingSessionId === session.id ? 'Logging out…' : 'Log out' }}
                        </button>
                      }
                  </div>
                </div>

                <!-- logout moved inline with location row -->
              </div>
            </div>
          }
        }
      </div>

      <div class="tw-flex tw-justify-end tw-mt-4" *ngIf="devicesLoaded && (sessions?.length ?? 0) > 1">
        <button
          type="button"
          class="tw-text-sm tw-font-semibold tw-text-red-600/90 hover:tw-text-red-700 tw-font-inter disabled:tw-opacity-60"
          [disabled]="revokingAllSessions"
          (click)="revokeOtherSessions()"
        >
          {{ revokingAllSessions ? 'Working…' : 'Sign out of other devices' }}
        </button>
      </div>
    </section>

    <!-- Password -->
    <section
      id="password"
      class="tw-w-full tw-flex tw-flex-col tw-m-auto tw-p-4 md:tw-px-6 tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-shadow-sm tw-rounded-xl tw-bg-white dark:tw-bg-gray-800"
      [ngClass]="{ 'tw-ring-2 tw-ring-yellow-300 tw-ring-offset-2 tw-ring-offset-gray-100 dark:tw-ring-offset-gray-900': showPasswordWarning }"
    >
      <div class="tw-mb-4 tw-flex tw-flex-col tw-gap-1 tw-items-start">
        <h2 class="tw-font-bold tw-text-gray-700 dark:tw-text-gray-100 tw-text-lg tw-font-inter">Password</h2>
        <p class="tw-text-sm tw-max-w-[660px] tw-text-gray-500 dark:tw-text-gray-300 tw-text-start tw-font-inter tw-font-normal">
          Update your password. You’ll be asked to verify it with MFA (if enabled) or your current password.
        </p>
      </div>

      <div class="tw-border-t tw-border-gray-200 dark:tw-border-gray-600 tw-pt-6" id="change-password">
        @if (showPasswordWarning) {
        <div class="tw-mb-4 tw-p-4 tw-bg-yellow-50 tw-rounded-lg tw-border tw-border-yellow-200">
          <div class="tw-flex tw-items-start tw-gap-3">
            <mat-icon class="tw-text-yellow-800 tw-flex-shrink-0">info</mat-icon>
            <div class="tw-text-sm tw-text-yellow-900 tw-font-inter">
              <div class="tw-font-semibold">Password update required</div>
              <div>To keep your account safe, we now require stronger passwords. Please update your password.</div>
            </div>
          </div>
        </div>
        }

        <h3 class="tw-font-semibold tw-text-gray-700 dark:tw-text-gray-100 tw-font-inter">Change password</h3>

        <div [formGroup]="passwordForm" class="tw-mt-4 tw-grid tw-grid-cols-1 md:tw-grid-cols-2 md:tw-gap-2 lg:tw-gap-3">
          <basic-input
            [control]="$any(passwordForm.controls.new_password)"
            [label]="'New password'"
            [id]="'profile-new-password'"
            [fieldType]="basicFieldType.PASSWORD"
            [type]="'password'"
            [allowClearButton]="false"
          ></basic-input>

          <basic-input
            [control]="$any(passwordForm.controls.new_password_confirmation)"
            [label]="'Confirm password'"
            [id]="'profile-confirm-password'"
            [fieldType]="basicFieldType.PASSWORD"
            [type]="'password'"
            [allowClearButton]="false"
          ></basic-input>
        </div>

        <div class="tw-flex tw-justify-end tw-mt-4">
          <button
            type="button"
            [disabled]="false"
            (click)="updatePassword()"
            class="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-lg tw-bg-blue-600 tw-px-4 tw-py-2.5 tw-text-sm tw-font-semibold tw-text-white hover:tw-bg-blue-700 disabled:tw-opacity-60 disabled:tw-cursor-not-allowed"
          >
            <mat-icon class="tw-text-inherit">lock_reset</mat-icon>
            Update password
          </button>
        </div>
      </div>
    </section>

    <!-- Password verify (MFA code) modal -->
    @if (passwordVerifyModalOpen) {
      <modal
        [id]="passwordVerifyModalId"
        [header]="'Verify to change password'"
        [showFooterDivider]="true"
        [showHeaderDivider]="true"
        [widthClass]="'tw-w-[520px] tw-max-w-[90vw]'"
        [heightClass]="'tw-h-auto tw-max-h-[85vh]'"
        [closeButtonEnabled]="true"
        [enableBackdropClose]="true"
        (onCloseModal)="closePasswordVerifyModal()"
      >
        <div slot="body" class="tw-px-6 tw-py-4">
          <p class="tw-text-gray-600 dark:tw-text-gray-200 !tw-mb-3">
            @if (passwordVerifyMode === 'email') {
              We sent a 6-digit verification code to your email. Enter it to confirm your password change.
            } @else {
              Enter the 6-digit verification code to confirm your password change.
            }
          </p>
          <label class="tw-block tw-text-sm tw-font-medium tw-text-gray-700 dark:tw-text-gray-200 tw-mb-1">Verification code</label>
          <div class="tw-flex tw-justify-center tw-items-center tw-gap-2" (paste)="onOtpPaste('passwordVerify', $event)">
            <input
              *ngFor="let _ of otpBoxes; let i = index"
              [id]="'passwordVerify-otp-' + i"
              type="text"
              inputmode="numeric"
              autocomplete="one-time-code"
              maxlength="1"
              class="tw-w-10 tw-h-12 tw-text-center tw-text-lg tw-font-semibold tw-border tw-border-gray-300 dark:tw-border-gray-600 tw-rounded-lg focus:tw-ring-2 focus:tw-ring-blue-500 focus:tw-border-blue-500 tw-bg-white dark:tw-bg-gray-800 dark:tw-text-gray-100"
              [formControl]="$any(passwordVerifyOtpControls[i])"
              (input)="onOtpInput('passwordVerify', i, $event)"
              (keydown)="onOtpKeydown('passwordVerify', i, $event)"
              (focus)="onOtpFocus($event)"
            />
          </div>
          @if (passwordVerifyLoading) {
            <div class="tw-text-sm tw-text-gray-500 dark:tw-text-gray-300 tw-mt-2">Working…</div>
          }
        </div>

        <div slot="footer" class="tw-flex tw-justify-end tw-gap-3 tw-px-6 tw-py-4">
          <button
            type="button"
            class="tw-rounded-lg tw-border tw-border-gray-300 tw-bg-white tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-gray-700 hover:tw-bg-gray-50"
            (click)="closePasswordVerifyModal()"
          >
            Cancel
          </button>
          <button
            type="button"
            class="tw-rounded-lg tw-bg-blue-600 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white hover:tw-bg-blue-700 disabled:tw-opacity-50"
            [disabled]="passwordVerifyLoading"
            (click)="confirmPasswordVerifyCode()"
          >
            Confirm
          </button>
        </div>
      </modal>
    }

    <!-- Current password modal (shown when MFA is disabled) -->
    @if (currentPasswordModalOpen) {
      <modal
        [id]="currentPasswordModalId"
        [header]="'Confirm current password'"
        [showFooterDivider]="true"
        [showHeaderDivider]="true"
        [widthClass]="'tw-w-[520px] tw-max-w-[90vw]'"
        [heightClass]="'tw-h-auto tw-max-h-[85vh]'"
        [closeButtonEnabled]="true"
        [enableBackdropClose]="true"
        (onCloseModal)="closeCurrentPasswordModal()"
      >
        <div slot="body" class="tw-px-6 tw-py-4">
          <p class="tw-text-gray-600 dark:tw-text-gray-200 !tw-mb-3">
            Enter your current password to confirm this change.
          </p>
          <basic-input
            [control]="$any(currentPasswordControl)"
            [label]="'Current password'"
            [id]="'profile-current-password'"
            [fieldType]="basicFieldType.PASSWORD"
            [type]="'password'"
            [allowClearButton]="false"
          ></basic-input>
          @if (currentPasswordLoading) {
            <div class="tw-text-sm tw-text-gray-500 dark:tw-text-gray-300 tw-mt-2">Working…</div>
          }
        </div>

        <div slot="footer" class="tw-flex tw-justify-end tw-gap-3 tw-px-6 tw-py-4">
          <button
            type="button"
            class="tw-rounded-lg tw-border tw-border-gray-300 tw-bg-white tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-gray-700 hover:tw-bg-gray-50"
            (click)="closeCurrentPasswordModal()"
          >
            Cancel
          </button>
          <button
            type="button"
            class="tw-rounded-lg tw-bg-blue-600 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white hover:tw-bg-blue-700 disabled:tw-opacity-50"
            [disabled]="currentPasswordLoading"
            (click)="confirmCurrentPassword()"
          >
            Confirm
          </button>
        </div>
      </modal>
    }

      <!-- MFA Modal -->
      @if (mfaModalOpen) {
      <modal
        [id]="mfaModalId"
        [header]="mfaModalHeader"
        [showFooterDivider]="true"
        [showHeaderDivider]="true"
        [widthClass]="'tw-w-[600px] tw-max-w-[90vw]'"
        [heightClass]="'tw-h-auto tw-max-h-[85vh]'"
        [closeButtonEnabled]="true"
        [enableBackdropClose]="true"
        (onCloseModal)="onMfaModalClosed()"
      >
        <div slot="body" class="tw-px-6 tw-py-4">
          @if (mfaModalMode === 'enable' && mfaModalFactor === MFA_FACTOR_TYPE.APP && !mfaShowRecoveryCodes) {
            @if (mfaModalLoading && !authenticatorResponse?.qr_png_base64) {
              <p class="tw-text-gray-600">Loading…</p>
            } @else {
              <p class="tw-text-gray-600 !tw-mb-3">Scan the QR code with Google Authenticator (or another app), then enter the 6-digit code below.</p>
              @if (authenticatorResponse?.qr_png_base64) {
                <div class="tw-flex tw-justify-center tw-mb-4">
                  <img [src]="authenticatorResponse.qr_png_base64" alt="QR code" class="tw-w-48 tw-h-48 tw-border tw-border-gray-200 tw-rounded-lg" />
                </div>
              }
              <label class="tw-block tw-text-sm tw-font-medium tw-text-gray-700 dark:tw-text-gray-200 tw-mb-1">Verification code</label>
              <div class="tw-flex tw-justify-center tw-items-center tw-gap-2" (paste)="onOtpPaste('mfa', $event)">
                <input
                  *ngFor="let _ of otpBoxes; let i = index"
                  [id]="'mfa-otp-' + i"
                  type="text"
                  inputmode="numeric"
                  autocomplete="one-time-code"
                  maxlength="1"
                  class="tw-w-10 tw-h-12 tw-text-center tw-text-lg tw-font-semibold tw-border tw-border-gray-300 dark:tw-border-gray-600 tw-rounded-lg focus:tw-ring-2 focus:tw-ring-blue-500 focus:tw-border-blue-500 tw-bg-white dark:tw-bg-gray-800 dark:tw-text-gray-100"
                  [formControl]="$any(mfaOtpControls[i])"
                  (input)="onOtpInput('mfa', i, $event)"
                  (keydown)="onOtpKeydown('mfa', i, $event)"
                  (focus)="onOtpFocus($event)"
                />
              </div>
            }
          }

          @if (mfaModalMode === 'enable' && mfaShowRecoveryCodes) {
            <p class="tw-text-gray-700 dark:tw-text-gray-200 tw-font-medium !tw-mb-4">Keep these recovery codes safe. You can use them to access your account if you lose your device.</p>
            <div class="tw-grid tw-grid-cols-2 tw-gap-2 tw-mb-4">
              @for (code of (authenticatorResponse?.recovery_codes ?? []); track code) {
                <div class="tw-px-3 tw-py-2 tw-bg-gray-100 dark:tw-bg-gray-700 tw-rounded tw-font-mono tw-text-sm tw-break-all">{{ code }}</div>
              }
            </div>
          }

          @if (mfaModalMode === 'enable' && mfaModalFactor !== MFA_FACTOR_TYPE.APP && !mfaShowRecoveryCodes) {
            <div class="tw-prose tw-max-w-none tw-mb-4 dark:tw-text-gray-200">
              We'll send a verification code to your {{ mfaModalFactor === MFA_FACTOR_TYPE.EMAIL ? 'email' : 'phone' }}. Enter the code below to enable two-factor authentication.
            </div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-gray-700 dark:tw-text-gray-200 tw-mb-1">Verification code</label>
            <div class="tw-flex tw-justify-center tw-items-center tw-gap-2" (paste)="onOtpPaste('mfa', $event)">
              <input
                *ngFor="let _ of otpBoxes; let i = index"
                [id]="'mfa-otp-' + i"
                type="text"
                inputmode="numeric"
                autocomplete="one-time-code"
                maxlength="1"
                class="tw-w-10 tw-h-12 tw-text-center tw-text-lg tw-font-semibold tw-border tw-border-gray-300 dark:tw-border-gray-600 tw-rounded-lg focus:tw-ring-2 focus:tw-ring-blue-500 focus:tw-border-blue-500 tw-bg-white dark:tw-bg-gray-800 dark:tw-text-gray-100"
                [formControl]="$any(mfaOtpControls[i])"
                (input)="onOtpInput('mfa', i, $event)"
                (keydown)="onOtpKeydown('mfa', i, $event)"
                (focus)="onOtpFocus($event)"
              />
            </div>
            <div class="tw-mt-4 tw-flex tw-flex-col tw-items-center tw-gap-2">
              <div class="tw-text-xs tw-text-gray-600 dark:tw-text-gray-300">
                Didn’t get the {{ mfaModalFactor === MFA_FACTOR_TYPE.EMAIL ? 'email' : 'SMS' }}?
              </div>
              <button
                type="button"
                class="tw-text-sm tw-font-semibold tw-text-blue-600 dark:tw-text-blue-400 disabled:tw-opacity-60"
                [disabled]="mfaResendSecondsRemaining > 0"
                (click)="resendMfaCode()"
              >
                Resend
                @if (mfaResendSecondsRemaining > 0) {
                  <span class="tw-ml-1">({{ mfaResendSecondsRemaining }}s)</span>
                }
              </button>
            </div>
          }

          @if (mfaModalMode === 'disable') {
            <p class="tw-text-gray-600 dark:tw-text-gray-300 !tw-mb-3">
              Enter a verification code from {{ mfaModalFactor != null ? getMfaFactorLabel(mfaModalFactor) : '' }} or use a recovery code.
            </p>

            <label class="tw-block tw-text-sm tw-font-medium tw-text-gray-700 dark:tw-text-gray-200 tw-mb-1">Verification code</label>
            <div class="tw-flex tw-justify-center tw-items-center tw-gap-2" (paste)="onOtpPaste('mfa', $event)">
              <input
                *ngFor="let _ of otpBoxes; let i = index"
                [id]="'mfa-otp-' + i"
                type="text"
                inputmode="numeric"
                autocomplete="one-time-code"
                maxlength="1"
                class="tw-w-10 tw-h-12 tw-text-center tw-text-lg tw-font-semibold tw-border tw-border-gray-300 dark:tw-border-gray-600 tw-rounded-lg focus:tw-ring-2 focus:tw-ring-blue-500 focus:tw-border-blue-500 tw-bg-white dark:tw-bg-gray-800 dark:tw-text-gray-100"
                [formControl]="$any(mfaOtpControls[i])"
                (input)="onOtpInput('mfa', i, $event)"
                (keydown)="onOtpKeydown('mfa', i, $event)"
                (focus)="onOtpFocus($event)"
              />
            </div>

            @if (mfaModalFactor === MFA_FACTOR_TYPE.EMAIL || mfaModalFactor === MFA_FACTOR_TYPE.PHONE) {
              <div class="tw-mt-4 tw-flex tw-flex-col tw-items-center tw-gap-2">
                <div class="tw-text-xs tw-text-gray-600 dark:tw-text-gray-300">
                  Didn’t get the {{ mfaModalFactor === MFA_FACTOR_TYPE.EMAIL ? 'email' : 'SMS' }}?
                </div>
                <button
                  type="button"
                  class="tw-text-sm tw-font-semibold tw-text-blue-600 dark:tw-text-blue-400 disabled:tw-opacity-60"
                  [disabled]="mfaResendSecondsRemaining > 0"
                  (click)="resendMfaCode()"
                >
                  Resend
                  @if (mfaResendSecondsRemaining > 0) {
                    <span class="tw-ml-1">({{ mfaResendSecondsRemaining }}s)</span>
                  }
                </button>
              </div>
            }

            <div class="tw-my-4 tw-flex tw-items-center tw-gap-3">
              <div class="tw-h-px tw-flex-1 tw-bg-gray-200 dark:tw-bg-gray-600"></div>
              <div class="tw-text-xs tw-text-gray-500 dark:tw-text-gray-300">or</div>
              <div class="tw-h-px tw-flex-1 tw-bg-gray-200 dark:tw-bg-gray-600"></div>
            </div>

            <basic-input
              [label]="'Recovery code'"
              [placeholder]="'Enter a recovery code'"
              [id]="'mfa-recovery-code'"
              [mode]="BasicInputMode.INLINE"
              [allowClearButton]="false"
              [control]="$any(mfaRecoveryCodeControl)"
            ></basic-input>
          }
        </div>
        <div slot="footer" class="tw-flex tw-justify-end tw-gap-2 tw-py-4 tw-px-6">
          @if (mfaModalMode === 'enable' && mfaShowRecoveryCodes) {
            <button type="button" class="tw-rounded-lg tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-px-3 tw-py-2 tw-text-sm" (click)="copyRecoveryCodes()">Copy codes</button>
            <a
              class="tw-rounded-lg tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-px-3 tw-py-2 tw-text-sm tw-text-gray-700 dark:tw-text-gray-100 hover:tw-bg-gray-50 dark:hover:tw-bg-gray-800"
              [href]="'data:text/plain;charset=utf-8,' + encodeURIComponent((authenticatorResponse?.recovery_codes ?? []).join('\n'))"
              download="micetribe-recovery-codes.txt"
            >
              Download codes
            </a>
            <button type="button" class="tw-rounded-lg tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-px-3 tw-py-2 tw-text-sm" (click)="closeMfaModal()">Close</button>
          } @else {
            <button type="button" class="tw-rounded-lg tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-px-3 tw-py-2 tw-text-sm" (click)="closeMfaModal()">Cancel</button>
            @if (mfaModalMode === 'enable' && mfaModalFactor === MFA_FACTOR_TYPE.APP) {
              <button
                type="button"
                class="tw-rounded-lg tw-bg-blue-600 tw-text-white tw-px-3 tw-py-2 tw-text-sm disabled:tw-opacity-60"
                [disabled]="mfaModalLoading || !mfaOtpCode?.trim()"
                (click)="confirmMFA()"
              >
                {{ mfaModalLoading ? 'Confirming…' : 'Confirm' }}
              </button>
            }
            @if (mfaModalMode === 'enable' && mfaModalFactor !== MFA_FACTOR_TYPE.APP) {
              <button
                type="button"
                class="tw-rounded-lg tw-bg-blue-600 tw-text-white tw-px-3 tw-py-2 tw-text-sm disabled:tw-opacity-60"
                [disabled]="!mfaOtpCode?.trim()"
                (click)="confirmMFA()"
              >
                Enable
              </button>
            }
            @if (mfaModalMode === 'disable') {
              <button
                type="button"
                class="tw-rounded-lg tw-bg-blue-600 tw-text-white tw-px-3 tw-py-2 tw-text-sm disabled:tw-opacity-60"
                [disabled]="mfaModalLoading"
                (click)="confirmDisableMFA()"
              >
                {{ mfaModalLoading ? 'Disabling…' : 'Yes, disable' }}
              </button>
            }
          }
        </div>
      </modal>
      }

      <!-- Device location modal (static map + Google Maps link) -->
      @if (deviceLocationModalOpen) {
      <modal
        [id]="deviceLocationModalId"
        [header]="'Device location'"
        [showFooterDivider]="true"
        [showHeaderDivider]="true"
        [widthClass]="'tw-w-[720px] tw-max-w-[95vw]'"
        [heightClass]="'tw-h-auto tw-max-h-[85vh]'"
        [closeButtonEnabled]="true"
        [enableBackdropClose]="true"
        (onCloseModal)="closeDeviceLocation()"
      >
        <div slot="body" class="tw-px-6 tw-py-4">
          <div class="tw-text-sm tw-text-gray-600 dark:tw-text-gray-200 tw-mb-3">
            {{ deviceLocationLabel }}
          </div>
          @if (deviceLocationLoading) {
            <div class="tw-text-sm tw-text-gray-500 dark:tw-text-gray-300">Loading map…</div>
          } @else {
            <a
              *ngIf="deviceLocationMapUrl && deviceLocationGoogleMapsUrl"
              class="tw-block tw-rounded-xl tw-overflow-hidden tw-border tw-border-gray-200 dark:tw-border-gray-600 hover:tw-opacity-95 tw-transition"
              [href]="deviceLocationGoogleMapsUrl"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img [src]="deviceLocationMapUrl" alt="Map" class="tw-w-full tw-h-auto tw-block" />
            </a>
            <div *ngIf="!deviceLocationMapUrl" class="tw-text-sm tw-text-gray-500 dark:tw-text-gray-300">
              Map not available.
            </div>
          }

          <div class="tw-mt-4 tw-flex tw-justify-end">
            <a
              *ngIf="deviceLocationGoogleMapsUrl"
              class="tw-text-sm tw-font-semibold tw-text-blue-600 dark:tw-text-blue-400 hover:tw-underline"
              [href]="deviceLocationGoogleMapsUrl"
              target="_blank"
              rel="noopener noreferrer"
            >
              Open in Google Maps
            </a>
          </div>
        </div>

        <div slot="footer" class="tw-flex tw-justify-end tw-gap-2 tw-py-4 tw-px-6">
          <button
            type="button"
            class="tw-rounded-lg tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-px-3 tw-py-2 tw-text-sm"
            (click)="closeDeviceLocation()"
          >
            Close
          </button>
        </div>
      </modal>
      }
  </div>
</div>
} @else {
<app-loading-screen></app-loading-screen>
}
